import actionTypes from './actionTypes';

export const fetch = ({
  reducerName, url, params, options,
}) => ({
  type: actionTypes.FETCH,
  reducerName,
  payload: {
    url,
    params,
    options,
  },
});

export const fetched = ({ reducerName, data }) => ({
  type: actionTypes.FETCHED,
  reducerName,
  payload: {
    data,
  },
});

export const failed = ({ reducerName }) => ({
  type: actionTypes.FAILED,
  reducerName,
});

export const merge = ({ reducerName, data }) => ({
  type: actionTypes.MERGE,
  reducerName,
  payload: {
    data,
  },
});
